import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/garden-size-info/garden-size-info.module.scss';

const GardenSizeInfoModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <Content />
    </Modal>
  );
};

const Content = () => (
  <div className={styles.gardenSizeInfoModal}>
    <p className={styles.gardenSizeHeader}>
      To figure out your garden’s square footage,{' '}
      <strong>multiply the length by the width,</strong> or, estimate it with
      our guide:
    </p>

    <img
      alt="Small garden"
      className={styles.gardenSizeImg}
      height="194"
      width="290"
      src="/images/garden-funnel/ex-small.png?v1"
      srcSet="/images/garden-funnel/ex-small.png?v1 1x, /images/garden-funnel/ex-small@2x.png?v1 2x"
    />
    <p className={styles.gardenSizeImgLabel}>
      <span>Extra small garden:</span> 0-250 sq. ft.
    </p>

    <img
      alt="Small to medium-sized"
      className={styles.gardenSizeImg}
      height="194"
      width="290"
      src="/images/garden-funnel/sm-med.png?v1"
      srcSet="/images/garden-funnel/sm-med.png?v1 1x, /images/garden-funnel/sm-med@2x.png?v1 2x"
    />
    <p className={styles.gardenSizeImgLabel}>
      <span>Small to medium-sized garden:</span>
      <br />
      250-500 sq. ft.
    </p>

    <img
      alt="Large garden"
      className={styles.gardenSizeImg}
      height="194"
      width="290"
      src="/images/garden-funnel/large.png?v1"
      srcSet="/images/garden-funnel/large.png?v1 1x, /images/garden-funnel/large@2x.png?v1 2x"
    />
    <p className={styles.gardenSizeImgLabel}>
      <span>Large garden:</span> 500-1,000 sq. ft.
    </p>
  </div>
);

export default GardenSizeInfoModal;
